import Link from 'components/Globals/Base/Link';
import HEADER_NAVIGATION from 'constants/testsIds/headerNavigation';
import { UserCircle } from 'icons/UserCircle';
import { useState } from 'react';
import logOut from 'services/Piano/logOut';
import { DebugLinkLogger } from '@/app_components/header/DebugLinkLogger';
import * as S from './MyAccountStyles';
import { useMyAccountLinks } from '@/app_lib/hooks/useMyAccountLinks';

export interface MyAccountProps {
  className?: string;
}

const MyAccount = ({ className }: MyAccountProps) => {
  const myAccountLinks = useMyAccountLinks();
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  return (
    <S.MyAccountWrapper
      className={`${className} ${isSubMenuOpen ? 'open' : ''}`}
      data-cy={HEADER_NAVIGATION.MY_ACCOUNT_DROPDOWN}
    >
      <S.UserButton
        type='button'
        onClick={() => setIsSubMenuOpen(!isSubMenuOpen)}
        data-cy='userIconBtn'
      >
        <UserCircle />
      </S.UserButton>

      <S.AccordionWrapper className={isSubMenuOpen ? 'open' : ''}>
        <S.MyAccountLink
          href='/my-account/'
          className='my-account-link'
        >
          My Account
        </S.MyAccountLink>
        <S.Arrow className='arrow' />
      </S.AccordionWrapper>

      <S.SubMenu className='submenu'>
        {myAccountLinks.map((item) => {
          const trimmedLabel = item.label.trim();
          const linkElement = (
            <Link
              href={item.href}
              aria-label={`Navigate to ${trimmedLabel} section of My Account`}
              type='primary'
              hasRightArrow={false}
              data-cy={`my-account-${trimmedLabel.toLowerCase().replace(' ', '-')}-navlink`}
            >
              {trimmedLabel}
            </Link>
          );

          return (
            <S.SubMenuItem key={item.href}>
              {item.href === '/account/subscriptions/' ? <DebugLinkLogger>{linkElement}</DebugLinkLogger> : linkElement}
            </S.SubMenuItem>
          );
        })}
        <S.SubMenuItem>
          <button
            type='button'
            onClick={logOut}
            data-cy='logoutBtnDesktop'
          >
            Sign Out
          </button>
        </S.SubMenuItem>
      </S.SubMenu>
    </S.MyAccountWrapper>
  );
};

export default MyAccount;
